import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-shop-list",
  "use": "icon-shop-list-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" id=\"icon-shop-list\"><defs><style type=\"text/css\"></style></defs><path d=\"M256 128h640v85.333H256V128zM256 298.667h640v85.333H256v-85.333zM256 469.333h640v85.333H256v-85.333zM256 640h512v85.333H256V640zM256 810.667h512v85.333H256v-85.333z\" p-id=\"2235\" /><path d=\"M85.333 128h85.333v85.333H85.333V128zM85.333 298.667h85.333v85.333H85.333v-85.333zM85.333 469.333h85.333v85.333H85.333v-85.333zM85.333 640h85.333v85.333H85.333V640zM85.333 810.667h85.333v85.333H85.333v-85.333z\" p-id=\"2236\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/shop-list.svg
// module id = e4vM
// module chunks = 29